import constants from "./constants";
import { isDriverReadyForDispatch } from "../utils/index";
import { sortBy } from "lodash";

const getValidEquipmentStatuses = (validEquipmentStatusList) => {
  return `Valid status: ${
    validEquipmentStatusList.length === 0
      ? 'None'
      : validEquipmentStatusList.join(', ')
  }`;
};

const isDriverAvailableForDispatch = (driverCurrentStatus, driverStatusConfig) => {
  return (
    driverStatusConfig.isAllowedToDispatch && driverStatusConfig.status.includes(driverCurrentStatus)
  );
};

const getEquipmentStatusesWithAllowedDispatch = (equipmentStatusConfig) => {
  return equipmentStatusConfig
    .filter((equipmentStatus) => equipmentStatus.isAllowedToDispatch)
    .map((equipmentStatus) => equipmentStatus.status);
};

const getEquipmentStatusesVisibleForDispatch = (equipmentStatusConfig) => {
  return sortBy(
    equipmentStatusConfig.filter((equipmentStatus) => equipmentStatus.isVisibleOnDispatch),
    'sortOrder'
  ).map((equipmentStatus) => equipmentStatus.status);
};

const getTrailerError = ({trailer, trailersData, trailerStatusConfig}) => {
  let error = "";
  const TRAILER_VALID_STATUS = getEquipmentStatusesWithAllowedDispatch(trailerStatusConfig);
  if (!trailer?.trailerNumber) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  } else if (!TRAILER_VALID_STATUS.includes(trailer?.trailerStatus)) {
    error = getValidEquipmentStatuses(TRAILER_VALID_STATUS);
  } else if (
    trailersData.filter(
      (t) => trailer.trailerId?.toLowerCase() === t.trailerId?.toLowerCase()
    ).length > 1
  ) {
    error = constants.ERROR_MESSAGES.DUPLICATE_TRAILER;
  }
  return error;
};

const getDollyError = ({dolly, trailersData, dollyStatusConfig}) => {
  let error = "";
  const DOLLY_VALID_STATUS = getEquipmentStatusesWithAllowedDispatch(dollyStatusConfig);
  if (!dolly) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  } else if (!DOLLY_VALID_STATUS.includes(dolly?.dollyStatus)) {
    error = getValidEquipmentStatuses(DOLLY_VALID_STATUS);
  } else if (
    trailersData.filter(
      (t) =>
      t.dolly?.value?.toLowerCase() === dolly.value?.toLowerCase() &&
      dolly.label !== constants.ADHOC_DOLLY
    ).length > 1
  ) {
    error = constants.ERROR_MESSAGES.DUPLICATE_DOLLY;
  }
  return error;
};

const getTractorError = ({tractor, tractorStatusConfig, isStraightTruckTrailer}) => {
  let error = null;
  if (!tractor) {
    return constants.ERROR_MESSAGES.REQUIRED;
  }  
  // no validations required if straight truck
  if (tractor && tractor.isStraightTruck){
    return error
  } 
  // if straight truck is selected, tractor should be straight truck
  if(isStraightTruckTrailer && !tractor.isStraightTruck){
    return constants.ERROR_MESSAGES.STRAIGHT_TRUCK_REQUIRED;
  }
  const TRACTOR_VALID_STATUS = getEquipmentStatusesWithAllowedDispatch(tractorStatusConfig);
  if (!TRACTOR_VALID_STATUS.includes(tractor.tractorStatus)) {
    error = getValidEquipmentStatuses(TRACTOR_VALID_STATUS);
  }
  return error;
};

const getDriverError = ({driverData, driverStatusConfig, terminalOffset, isDriverNotYetDispatched}) => {
  let error = "";
  let statusError = "";
  if (!driverData) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  } else if(!isDriverNotYetDispatched){
    error = constants.ERROR_MESSAGES.DRIVER_DISPATCHED;
  } else if (!isDriverAvailableForDispatch(driverData.as400Status, driverStatusConfig)) {
    statusError = `The current driver status is "${driverData.as400Status}"`;
    error = constants.ERROR_MESSAGES.VALID_DRIVER_STATUS;
  } else if (
    !isDriverReadyForDispatch({driverClockedInTime:driverData.clockedInTime, isCompanyDriver: driverData.isCompanyDriver, terminalOffset:terminalOffset})
  ) {
    error = constants.ERROR_MESSAGES.DRIVER_CLOCKED_IN_STATUS;
  }
  return { error, statusError };
};
const getUpdatedTrailerError = ({
  trailerDetails,
  trailerDetailsErrors,
  trailerStatusConfig,
  dollyStatusConfig
}) => {
  return trailerDetails.map((trailer, index) => {
    let trailerError = getTrailerError({
      trailer,
      trailersData: trailerDetails,
      trailerStatusConfig
    });
    let dollyError = getDollyError({
      dolly: trailer.dolly, 
      trailersData: trailerDetails,
      dollyStatusConfig,
    });
    if (
      trailerDetailsErrors[index]?.trailerNumber !== trailerError &&
      [constants.ERROR_MESSAGES.REQUIRED].includes(trailerError)
    ) {
      trailerError = trailerDetailsErrors[index]?.trailerNumber;
    }
    if (
      index !== 0 &&
      trailerDetailsErrors[index]?.dolly !== dollyError &&
      [constants.ERROR_MESSAGES.REQUIRED].includes(dollyError)
    ) {
      dollyError = trailerDetailsErrors[index]?.dolly;
    }
    return {
      trailerNumber: trailerError,
      dolly: dollyError
    };
  });
};

const getEventFailureMessage = () => {
  return constants.ERROR_MESSAGES.DISPATCH_DRIVER_EVENT_FAILED;
}

const getUniqueEquipmentNumber = (equipmentNumber, equipmentScac = null) => {
  return equipmentScac ? `${equipmentNumber}_${equipmentScac}` : equipmentNumber;
};

export {
  getTrailerError,
  getTractorError,
  getDollyError,
  getDriverError,
  getUpdatedTrailerError,
  getEquipmentStatusesVisibleForDispatch,
  getEventFailureMessage,
  getUniqueEquipmentNumber,
  getEquipmentStatusesWithAllowedDispatch,
};
